import classNames from 'classnames';

import { Icon } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { adengiBannerImage, ADengiLogoSvg } from '@src/assets/adengiBanner';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';

import { SponsoredBadge } from '../SponsoredBadge/SponsoredBadge';
import { SponsoredMenu } from '../SponsoredMenu/SponsoredMenu';

import { ADENGI_COMPANY_NAME, ADENGI_URL } from './ADengiBanner.config';
import styles from './ADengiBanner.module.scss';

export function ADengiBanner() {
  const isMobile = useIsMobile();

  const sizes = isMobile ? { width: 130, height: 80 } : { width: 400 };
  return (
    <>
      <div className={classNames(styles.advertising, 'desktop:hidden')}>
        <SponsoredMenu company={ADENGI_COMPANY_NAME} token="2W5zFGg59GC" />
        <SponsoredBadge link={ADENGI_URL} />
      </div>
      <div className={styles.container}>
        <Icon icon={<ADengiLogoSvg />} className={styles.logo} />
        <OptimizedPicture img={adengiBannerImage} alt="Банер" {...sizes} />

        <div className={classNames(styles.advertising, 'mobile:hidden')}>
          <SponsoredMenu company={ADENGI_COMPANY_NAME} token="2W5zFGg59GC" />
          <SponsoredBadge link={ADENGI_URL} />
        </div>
      </div>
    </>
  );
}
